import { createApiQueryHook, IApiQueryFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { IMissionResource } from "../types";

export type IMissionQueryParameters = {
    mission?: RelationalValue<IMissionResource>;
};

export type IMissionQueryResult = IMissionResource;

export const missionQuery: IApiQueryFunction<IMissionQueryParameters> = ({ mission }) => {
    if (!mission) {
        return;
    }

    return {
        method: "GET",
        url: `/missions/${mapRelationalValue(mission)}`,
    };
};

export const useMissionQuery = createApiQueryHook<IMissionQueryParameters, IMissionQueryResult>(missionQuery);
